<template>
  <dv-border-box-7>

    <div id="leftLevel">
      <div class="bg-color-black" style="height: 100%;">
        <div class="d-flex pt-2 pl-2" style="height:30px;">
          <div style="font-size:16px;color:#5cd9e8;float:left;padding:2px">
            最新挂网项目

            <dv-decoration-1 style="width:1.25rem;height:.15rem; position:relative;top:-.0375rem;" />
          </div>
          <!-- <div style="float:right"><i class="el-icon-more-outline" style="font-size:20px;color:#5cd9e8;"></i>
          </div> -->
        </div>

        <div style="width:100%;height:88%">
          <dv-scroll-board :config="config" style="width:100%;height:100%" />
        </div>


      </div>
    </div>
  </dv-border-box-7>

</template>

<script>
import * as echarts from "echarts";

import axios from 'axios'
export default {
  name: "lef",
  watch: {
    areaData(val) {
      this.areaDataObj = val;
    }
  },
  data() {
    return {
      selectType: "", //类别查询
      selectAreaNum: "", //面积查询
      itemNum: "", //项目编号
      itemName: "", //项目名称
      selectState: 0,
      chartData: [],
      unitCode: localStorage.getItem("unitCode"),
      config: {
        headerHeight: "30",
        header: ['项目名称', '成交价', '成交日期'],
        data: []
      }



    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      const action = "/web/v1/transferList?pageNum=1&pageSize=20&state=&unitCode=" + this.unitCode;
      const {
        data: res
      } = await this.$http.get(action);
      var returnData = res.data.content;
      var arrData = [];
      for (var i = 0; i < returnData.length; i++) {
        var type = "";
        if (returnData[i].tradeWay == 1) { type = "自由竞价"; }
        if (returnData[i].tradeWay == 2) { type = "网络竞价"; }
        if (returnData[i].tradeWay == 3) { type = "拍卖"; }
        if (returnData[i].tradeWay == 4) { type = "招投标"; }
        if (returnData[i].tradeWay == 5) { type = "其他"; }
        if (returnData[i].tradeWay == 6) { type = "招商"; }
        var oneArr = [returnData[i].itemName + "",  returnData[i].publishTime.substr(0, 10) + ""];
        arrData.push(oneArr);  
      }
      this.config = {
        data: arrData,
        header: ['项目名称', '挂网时间'],
        columnWidth: [450, 100],
        headerBGC: "#02424E",
        rowNum:9,
      };
    },
    async getEmnusByType(type) {
      const action = "/web/queryEnumsByType/" + type;
      const {
        data: res
      } = await this.$http.get(action);
      this.emnus = res.data;
    },
    getEnumByCode(code) {
      return this.emnus.find(d => d.code === code).desc;
    },
  }
  }
</script>

<style lang="scss" scoped>
::v-deep .dv-scroll-board .header .row-item{
  height: 40px !important;
}

.dv-scroll-board .header {
  width: 100% !important;
}

#leftLevel {
  padding: 0.2rem;
  height: 100%;
  min-width: 3.75rem;
  border-radius: 0.0625rem;

  .bg-color-black {
    height: 98%;
    border-radius: 0.125rem;
  }

  .text {
    color: #c3cbde;
  }

  #parent::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  #parent {
    scrollbar-width: none;
    /* firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
    overflow-x: hidden;
    overflow-y: auto;
  }
}
</style>
